/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * How multi-remote authn challenges are presented: chain | interactive.
 */
export const AuthnChallengeMode = {
  Chain: "chain",
  Interactive: "interactive",
} as const;
/**
 * How multi-remote authn challenges are presented: chain | interactive.
 */
export type AuthnChallengeMode = ClosedEnum<typeof AuthnChallengeMode>;

/**
 * Form for creating an organization-owned user_session_issuer.
 */
export type CreateOrganizationUserSessionIssuerForm = {
  /**
   * How multi-remote authn challenges are presented: chain | interactive.
   */
  authnChallengeMode: AuthnChallengeMode;
  /**
   * Maximum issued user session lifetime, in hours.
   */
  sessionDurationHours: number;
  /**
   * Issuer slug. Unique for project-owned issuers; organization-owned issuer slugs may repeat.
   */
  slug: string;
  /**
   * Organization-level remote_session_client Speakeasy uses with the trusted issuer. Must be supplied together with trusted_remote_session_issuer_id.
   */
  trustedRemoteSessionClientId?: string | undefined;
  /**
   * Organization-level or global remote_session_issuer whose assertions this issuer trusts. Omit to leave enterprise-managed authorization disabled.
   */
  trustedRemoteSessionIssuerId?: string | undefined;
};

/** @internal */
export const AuthnChallengeMode$outboundSchema: z.ZodMiniEnum<
  typeof AuthnChallengeMode
> = z.enum(AuthnChallengeMode);

/** @internal */
export type CreateOrganizationUserSessionIssuerForm$Outbound = {
  authn_challenge_mode: string;
  session_duration_hours: number;
  slug: string;
  trusted_remote_session_client_id?: string | undefined;
  trusted_remote_session_issuer_id?: string | undefined;
};

/** @internal */
export const CreateOrganizationUserSessionIssuerForm$outboundSchema:
  z.ZodMiniType<
    CreateOrganizationUserSessionIssuerForm$Outbound,
    CreateOrganizationUserSessionIssuerForm
  > = z.pipe(
    z.object({
      authnChallengeMode: AuthnChallengeMode$outboundSchema,
      sessionDurationHours: z.int(),
      slug: z.string(),
      trustedRemoteSessionClientId: z.optional(z.string()),
      trustedRemoteSessionIssuerId: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        authnChallengeMode: "authn_challenge_mode",
        sessionDurationHours: "session_duration_hours",
        trustedRemoteSessionClientId: "trusted_remote_session_client_id",
        trustedRemoteSessionIssuerId: "trusted_remote_session_issuer_id",
      });
    }),
  );

export function createOrganizationUserSessionIssuerFormToJSON(
  createOrganizationUserSessionIssuerForm:
    CreateOrganizationUserSessionIssuerForm,
): string {
  return JSON.stringify(
    CreateOrganizationUserSessionIssuerForm$outboundSchema.parse(
      createOrganizationUserSessionIssuerForm,
    ),
  );
}
